export default __webpack_public_path__ + "static/media/Congratulations text.b9ab970b.svg";